import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragDropVertical = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M3.25 12a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM10 12a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm6.75 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM3.25 6.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm6.75 0A.75.75 0 1 1 10 8a.75.75 0 0 1 0-1.5Zm6.75 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
	})]
});
const ForwardRef = forwardRef(SvgDragDropVertical);
export { ForwardRef as ReactComponent };
